<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="px-8 pt-8 register-tabs-container">
                                <div class="vx-card__title mb-4">
                                    <!-- <h4 class="mb-4">Create Account</h4> -->
                                    <!-- <p>Fill the below form to create a new account.</p> -->
                                <h4 class="mb-4"><strong>비밀번호 변경</strong></h4>
                                <p>비밀번호를 변경하세요</p>
                                </div>
                                <vs-tabs>
                                  <vs-tab label="비밀번호">
                                    <vs-input
                                      ref="password"
                                      type="password"
                                      data-vv-validate-on="blur"
                                      v-validate="'required|min:6|max:10'"
                                      name="new_password"
                                      label-placeholder="새 비밀번호"
                                      placeholder="새 비밀번호"
                                      v-model="new_password"
                                      class="w-full mt-6"
                                      @change="newPasswordOutfocus()"/>
                                      <span id="newPassword"/>
                                      <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <vs-input
                                      type="password"
                                      v-validate="'min:6|max:10|confirmed:password'"
                                      data-vv-validate-on="blur"
                                      data-vv-as="password"
                                      name="confirm_password"
                                      label-placeholder="새 비밀번호 확인"
                                      placeholder="새 비밀번호 확인"
                                      v-model="confirm_password"
                                      class="w-full mt-6"
                                      @change="passwordMatch()"/>
                                      <span id="same"/><br>
                                      <!-- <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span> -->

                                    <vs-button class="float-right mt-6" @click="changePasswordConfirm()">완료</vs-button>
                                    <vs-button class="float-left mt-6" type="border" color="warning" @click="skip()">skip</vs-button>
                                  </vs-tab>
<!--
                                  <vs-tab label="Firebase">
                                    <register-firebase></register-firebase>
                                  </vs-tab>

                                  <vs-tab label="Auth0">
                                    <register-auth0></register-auth0>
                                  </vs-tab> -->
                                </vs-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>


<script>
export default {
  data() {
    return {
      new_password: '',
      confirm_password: '',
      changePasswordVal: false
    }
  },
  methods: {
    validatePassword(character) {
        return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/.test(character)
    },
    newPasswordOutfocus() {
      if (this.validatePassword(this.new_password) == true) {
        document.getElementById('newPassword').innerHTML = '사용이 가능합니다.'
        document.getElementById('newPassword').style.color = 'blue'
      } else {
        document.getElementById('newPassword').innerHTML = '특수문자, 숫자, 영어를 조합하여 작성해주세요.'
        document.getElementById('newPassword').style.color = 'red'
      }
    },
    passwordMatch() {
      // 새 비번과 새 비번 일치 확인
      if(!this.new_password){
        return
      }
      if (this.new_password == this.confirm_password) {
        document.getElementById('same').innerHTML='비밀번호가 일치합니다.'
        document.getElementById('same').style.color='blue'
        this.changePasswordVal = true
        return true
      }
      else {
        document.getElementById('same').innerHTML='비밀번호가 일치하지 않습니다.'
        document.getElementById('same').style.color='red'
        this.changePasswordVal = false
        return false
      }
    },
    changePasswordConfirm() {
      if (this.changePasswordVal === true && this.validatePassword(this.new_password) == true) {
        const payload = {
          new_password: this.new_password
        }
        this.$store.dispatch('auth/loginChangePassword', payload)
        .then((resolve) => {
          if(resolve.data.result == 'success'){
            this.$vs.notify({
              color: 'success',
              title: '완료',
              text: '비밀번호가 변경되었습니다.'
            })
            this.$router.push('/pages/space/create')
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '비밀번호를 다시 확인해주십시오.'
          })
        })
      }
    },
    skip () {
      this.$router.push('/pages/space/create')
    }
  }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;
  // font-family: sans-serif;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
